
import { Options } from "vue-class-component";
import { BaseDetail } from "@/script/core/view/BaseDetail";
import { Address } from "@/script/apps/user/entity/UserEntity";
import { ServiceContext, ServiceFactory } from "@/script/core/base/ServiceData";
import addressList from "@/script/core/util/Address";
import { AddressService } from "@/script/apps/user/service/AddressService";
import { ElMessage } from "element-plus";
import { Watch } from "vue-property-decorator";

@Options({})
export default class AddressDetail extends BaseDetail {
  private service = new AddressService();

  private regionProps = { value: "code", label: "name" };

  private regions = addressList;

  public initData(): ServiceContext {
    const data = ServiceFactory.build(
      "biz_user_address",
      "/user/address",
      "/user/address",
      this.service
    );
    data.entity = { user: { realName: "" } };
    return data;
  }

  private rules = {
    code: [{ required: true, message: "请输入编码", trigger: "blur" }],
    name: [{ required: true, message: "请输入名称", trigger: "blur" }],
  };

  public newEntity() {
    const entity: Address = {};
    return entity;
  }

  public afterLoad(data: any) {
    const address = data as Address;
    address.region = [];
    address.region.push(address.province!);
    address.region.push(address.city!);
    address.region.push(address.county!);
  }

  public beforeSave() {
    const address = this.entity as Address;
    address.province = this.entity.region[0];
    address.city = this.entity.region[1];
    address.county = this.entity.region[2];
    return true;
  }

  @Watch("entity.detail")
  private onDetailChanged(newVal: string, oldVal: string): void {
    this.updateFullAddress();
  }

  @Watch("entity.region")
  private onRegionChanged(newVal: string, oldVal: string): void {
    this.updateFullAddress();
  }

  private updateFullAddress() {
    const address = this.entity as Address;
    const nodes = (this.$refs.casRegions as any).getCheckedNodes();
    if (nodes.length > 0) {
      address.fullAddress = nodes[0].pathLabels.join("") + address.detail;
    }
  }
}
